import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { TESTIMONIALS } from "../../data/content";

export default function Testimonials() {
  const [i, setI] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setI((p) => (p + 1) % TESTIMONIALS.length), 6000);
    return () => clearInterval(t);
  }, []);
  const t = TESTIMONIALS[i];
  return (
    <section data-testid="testimonials-section" className="relative py-28 md:py-40 px-6 md:px-10">
      <div className="max-w-4xl mx-auto text-center">
        <span className="font-mono-x text-primary text-xs tracking-[0.35em]">/ 06 — CLIENT VOICES</span>
        <Quote className="w-10 h-10 text-primary mx-auto mt-8" />
        <div className="relative min-h-[240px] mt-6">
          <AnimatePresence mode="wait">
            <motion.div key={i} initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -20 }} transition={{ duration: 0.5 }}>
              <div className="flex justify-center gap-1 mb-6">
                {[...Array(t.rating)].map((_, s) => <Star key={s} className="w-5 h-5 fill-primary text-primary" />)}
              </div>
              <p className="font-heading font-medium text-2xl md:text-4xl leading-snug tracking-tight">"{t.quote}"</p>
              <div className="mt-8">
                <div className="font-bold">{t.name}</div>
                <div className="text-sm text-muted-foreground">{t.role}</div>
              </div>
            </motion.div>
          </AnimatePresence>
        </div>
        <div className="flex justify-center gap-2 mt-8">
          {TESTIMONIALS.map((_, d) => (
            <button key={d} data-testid={`testimonial-dot-${d}`} onClick={() => setI(d)}
              className={`h-2 rounded-full transition-all ${d === i ? "w-8 bg-primary" : "w-2 bg-border"}`} />
          ))}
        </div>
      </div>
    </section>
  );
}
